module.exports = __webpack_public_path__ + "img/deco.86aa3d13.png";